import {h} from 'preact';
import 'jquery-file-download';
import constants from "../../constants";
import designService from "../../service/designService";
import Renderer from "../../canvas/renderer";
import {useState} from "preact/hooks";
import {showDuplicatedDesign} from "../../util";
import LoadingSpinner from "../LoadingSpinner";

export default function MenuCopy({designId, toRoot, resizeData}) {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  function copy() {
    if (!name.trim()) return;

    setSaving(true);
    designService.updateDesign({
      id: designId,
      html: Renderer.getPagesContent()
    }).then(() => {
      resizeData = resizeData || {};
      designService.makeCopy(designId, name, resizeData.size, resizeData.width, resizeData.height, resizeData.unit).then(resp => {
        location.href = location.protocol + '//' + location.hostname + location.pathname + '?id=' + resp.data;
        setSaving(false);
      }).catch(() => {
        showDuplicatedDesign(name);
        setSaving(false);
      });
    })
  }

  return (
    <div className={'mn-cop'}>
      <header className={'sb'}>
        <a onClick={toRoot}>
          <svg>
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-arrow"}/>
          </svg>
        </a>
        <h2>Make a Copy</h2>
      </header>
      <section>
        <input type="text" placeholder="Design name..." onChange={ev => setName(ev.target.value)}/>
        <button className={"btn primary"} onClick={copy} disabled={saving}>
          {!saving && <span>Save</span>}
          {saving && <LoadingSpinner/>}
        </button>
      </section>
    </div>
  )
}
